<template>
  <div class="register">
    <v-stepper class="stepper" v-model="selectedStep">
      <!-- <h2>Registrierungsfortschritt</h2> -->
      <v-stepper-header>
        <v-stepper-step color="green" step="1"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="2"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="3"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="4"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="5"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="6"></v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step color="green" step="7" complete></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items class="items">
        <!-- <v-stepper-content class="content text-center" step="1">
          <h1>So funktioniert's:</h1>
          <br />
          <div class="icon-row">
            <img class="small-icon" src="@/assets/icons/register.png" alt />
          </div>
          <h2 class="text-xs-center">1. Kostenlose Registrierung</h2>
          <p>In wenigen Schritten zu deinem kostenlosen Account.</p>
          <br />
          <div class="icon-row">
            <img class="small-icon" src="@/assets/icons/profile.png" alt />
          </div>
          <h2 class="text-xs-center">2. Spieler-Profil anlegen</h2>
          <p>Umso mehr Informationen du hinterlegst, desto besser wirst du gefunden.</p>
          <br />
          <div class="icon-row">
            <img class="small-icon" src="@/assets/icons/talent.png" alt />
          </div>
          <h2 class="text-xs-center">3. Matching-Tool nutzen</h2>
          <p>Finde per Swipe den passenden Verein für deinen nächsten Karriereschritt.</p>
          <v-btn color="white green--text" @click="$router.push({name:'registerChoice'})">Zurück</v-btn>
          <v-btn color="green white--text" id="viewPlayer" @click="next">Weiter</v-btn>
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <div class="text-left">
            <h1>Login-Daten</h1>
            <br />
            <p>Zunächst brauchen wir deinen Namen, deine E-Mail-Adresse und ein sicheres Passwort.</p>
          </div>
          <br />
          <label>Vor- u. Nachname</label>
          <v-text-field :rules="[rules.required]" color="green" v-model="common_infos.name" solo></v-text-field>
          <label>E-Mail</label>
          <v-text-field :rules="[rules.required]" color="green" v-model="email" solo></v-text-field>
          <label>Passwort</label>
          <v-text-field
            v-model="password"
            :append-icon="showPW ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="showPW ? 'text' : 'password'"
            name="input-10-1"
            :loading="loading"
            solo
            color="green"
            hint="min. 8 Zeichen"
            counter
            @click:append="showPW = !showPW"
          ></v-text-field>
          <v-checkbox class="check_nospace" color="green" v-model="checkbox_anb">
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit den
                <a
                  target="_blank"
                  href="https://www.chance4talents.de/anbs.html"
                >ANB</a> der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>
          <v-checkbox class="check_nospace" color="green" v-model="checkbox_datenschutz">
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit der
                <a
                  target="_blank"
                  href="http://www.chance4talents.de/datenschutz.html"
                >Datenschutzerklärung</a> der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            :loading="loading"
            color="green white--text"
            id="registerPlayer"
            :disabled="password.length<8 || !common_infos.name || common_infos.name ==''|| !checkbox_anb || !checkbox_datenschutz"
            @click="registerPlayer(email,password,common_infos.name)"
          >Weiter</v-btn>
        </v-stepper-content> -->

        <v-stepper-content class="content" step="1">
          <h1>Gib jetzt deine persönlichen Daten ein.</h1>
          <h3>Schritt 1 von 2</h3>

          <hr class="green-line" />

          <label>Vorname <span>*</span></label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="common_infos.vorname"
            solo
          ></v-text-field>

          <label>Nachname <span>*</span></label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="common_infos.nachname"
            solo
          ></v-text-field>

          <label>
            Geburtsdatum
            <span>*</span>
          </label>
          <v-menu
            ref="menu"
            v-model="menu"
            locale="de"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            color="green"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                color="green"
                v-model="settings.birthday"
                prepend-icon="event"
                readonly
                solo
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              color="green"
              ref="picker"
              locale="de"
              v-model="settings.birthday"
              :max="new Date().toISOString().substr(0, 10)"
              min="1900-01-01"
            ></v-date-picker>
          </v-menu>

          <label>
            Geschlecht
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="sex"
            v-model="settings.gender"
            solo
          ></v-select>

          <label>Größe (in cm) <span>*</span></label>
          <v-text-field
            color="green"
            v-model="settings.size"
            mask="###"
            placeholder="z.B. 180"
            solo
          ></v-text-field>

          <label>Gewicht (in kg) <span>*</span></label>
          <v-text-field
            color="green"
            v-model="settings.weight"
            mask="###"
            placeholder="z.B. 75"
            solo
          />

          <v-btn color="white green--text" @click="backToRegister" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !common_infos.vorname ||
              !common_infos.nachname ||
              !settings.birthday ||
              !settings.gender ||
              !settings.size ||
              !settings.weight
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="2">
          <h1>Gib weitere persönliche Daten ein.</h1>
          <h3>Schritt 2 von 2</h3>

          <hr class="green-line" />

          <label> Nationalität <span>*</span> </label>
          <v-autocomplete
            :no-data-text="'Keine Einträge vorhanden'"
            :items="$store.state.nationalities"
            item-text="item_text"
            item-value="id"
            color="green"
            name="nationalities"
            v-model="settings.nationality"
            solo
            attach
          ></v-autocomplete>

          <label>Sprachen <span>*</span></label>
          <v-select
            solo
            v-model="settings.languages"
            color="green"
            :items="$store.state.languages"
            chips
            multiple
          ></v-select>

          <h2 class="middle_header">Aktueller Wohnsitz <span>*</span></h2>

          <!-- <label>Postleitzahl <span>*</span></label> -->
          <v-text-field
            color="green"
            v-model="common_infos.zip_code"
            mask="#####"
            placeholder="Postleitzahl"
            solo
          ></v-text-field>

          <!-- <label>Ort, Bundesland</label> -->
          <v-text-field
            color="green"
            v-model="common_infos.ort_bundesland"
            placeholder="Ort, Bundesland"
            solo
          ></v-text-field>

          <!-- <label>
            Wohnsitz (Land)
            <span>*</span>
          </label> -->
          <v-autocomplete
            color="green"
            :items="$store.state.countries"
            v-model="settings.place_of_living"
            placeholder="Land"
            solo
          ></v-autocomplete>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !(settings.languages && settings.languages.length) ||
              !settings.nationality ||
              !settings.place_of_living ||
              !common_infos.zip_code
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="3">
          <h1>Ein Profilbild ist immer vorteilhaft.</h1>
          <h3>Das kannst du auch später erledigen.</h3>

          <hr class="green-line" />

          <div v-if="common_infos.big_thumbnail" class="upload-change-wrapper">
            <img
              class="register-avatar register-avatar__big"
              :src="common_infos.big_thumbnail"
              alt=""
            />
            <label class="upload-label" for="upload-photo">Bild ändern</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>
          <div v-else class="upload-wrapper">
            <label class="upload-label" for="upload-photo">Bild auswählen</label>
            <input
              class="upload-file-input"
              @change="croppie"
              type="file"
              accept="image/*"
              name="photo"
              id="upload-photo"
            />
          </div>

          <br />
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn color="green white--text" @click="next">Weiter</v-btn>
        </v-stepper-content>

        <v-stepper-content class="content" step="4">
          <h1>Gib hier deine Spielerdaten ein.</h1>
          <h3>Schritt 1 von 2</h3>

          <hr class="green-line" />

          <label>
            Position
            <span>*</span>
          </label>
          <v-select
            color="green"
            @change="setSpecificPosition(settings.position)"
            :items="$store.state.positions"
            v-model="settings.position"
            solo
          ></v-select>

          <label v-if="settings.position && settings.position !== 'Torhüter'">
            Hauptposition ({{ settings.position ? settings.position : 'spezifisch' }})
            <span>*</span>
          </label>

          <v-select
            v-if="settings.position && settings.position !== 'Torhüter'"
            color="green"
            :items="playerSpecificPosition"
            v-model="settings.position_specific"
            solo
          ></v-select>

          <label>
            Nebenposition
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.secondPositions"
            v-model="settings.secondPosition"
            @change="setSpecificSecondPosition(settings.secondPosition)"
            solo
          ></v-select>

          <div
            v-if="
              settings.secondPosition &&
              !$store.state.positionsWithoutSpecific.includes(settings.secondPosition)
            "
          >
            <label
              >Nebenposition ({{
                settings.secondPosition ? settings.secondPosition : 'spezifisch'
              }})</label
            >
            <v-select
              color="green"
              :items="playerSpecificSecondPosition"
              v-model="settings.second_position_specific"
              solo
            ></v-select>
          </div>

          <label>Spielertyp <span>*</span></label>
          <v-select
            color="green"
            multiple
            :items="player_types"
            v-on:input="limiter"
            v-model="settings.player_type"
            solo
          ></v-select>

          <label>Bevorzugter Fuß<span>*</span></label>
          <v-select color="green" :items="foot" v-model="settings.foot" solo></v-select>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :disabled="
              !settings.foot ||
              !settings.position ||
              (settings.position !== 'Torhüter' && !settings.position_specific) ||
              !settings.secondPosition ||
              !settings.player_type
            "
            @click="next"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="5">
          <h1>Gib weitere Spielerdaten ein.</h1>
          <h3>Schritt 2 von 2</h3>

          <hr class="green-line" />

          <div class="row">
            <div style="display: inline-block">
              <v-switch
                color="green"
                v-model="settings.no_team"
                :label="settings.no_team ? 'Aktiver Spieler' : 'Vereinsloser Spieler'"
              ></v-switch>
            </div>
            <label>
              <span v-if="settings.no_team">Aktueller</span>
              <span v-else>Letzter</span>
              Verein
              <span>*</span>
            </label>
          </div>
          <v-text-field
            color="green"
            v-model="settings.currentTeam"
            solo
          ></v-text-field>

          <label>
            Region/Verband
            <span>*</span>
          </label>
          <v-select
            color="green"
            :items="$store.state.verband"
            v-model="settings.verband"
            solo
          ></v-select>

          <label v-if="settings.verband">Liga <span>*</span></label>
          <v-select
            v-if="settings.verband"
            color="green"
            :items="$store.state.filter_leagues[settings.verband]"
            item-text="league"
            item-value="category"
            return-object
            v-model="settings.category"
            solo
          ></v-select>
          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            @click="next"
            :disabled="!settings.verband || !settings.currentTeam || !settings.category"
            >Weiter</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="6">
          <h1>
            Zuletzt brauchen wir noch eine gültige E-Mail-Adresse und ein sicheres
            Passwort.
          </h1>

          <hr class="green-line" />

          <label>E-Mail</label>
          <v-text-field
            :rules="[rules.required]"
            color="green"
            v-model="email"
            solo
          ></v-text-field>

          <label>Passwort</label>
          <v-text-field
            v-model="password"
            :append-icon="showPW ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.min]"
            :type="showPW ? 'text' : 'password'"
            name="input-10-1"
            :loading="loading"
            solo
            color="green"
            hint="min. 8 Zeichen"
            counter
            @click:append="showPW = !showPW"
          ></v-text-field>

          <v-checkbox class="check_nospace" color="green" v-model="checkbox_anb">
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit den
                <a target="_blank" href="https://www.chance4talents.de/anbs.html"
                  >ANB</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-checkbox
            class="check_nospace"
            color="green"
            v-model="checkbox_datenschutz"
          >
            <template v-slot:label>
              <div class="check_label">
                Ich erkläre mich mit der
                <a target="_blank" href="http://www.chance4talents.de/datenschutz.html"
                  >Datenschutzerklärung</a
                >
                der CHANCE4TALENTS GmbH einverstanden.
              </div>
            </template>
          </v-checkbox>

          <v-btn color="white green--text" @click="back" text>Zurück</v-btn>
          <v-btn
            color="green white--text"
            :loading="loading"
            :disabled="
              password.length < 8 || !email || !checkbox_anb || !checkbox_datenschutz
            "
            @click="registerPlayer()"
            >Erledigt</v-btn
          >
        </v-stepper-content>

        <v-stepper-content class="content" step="7">
          <h1 style="color: green; margin: 20px; 0">
            Glückwunsch, deine Registrierung war erfolgreich.
          </h1>
          <h3 style="color: black; margin-bottom: 10px">
            Jetzt fehlt nur noch die offizielle Verifizierung deines Accounts, um den
            begehrten blauen C4T-Ring zu erhalten!
          </h3>
          <h3>
            Geh dazu bitte in dein E-Mail Postfach und bestätige per blauen Button deine
            angegebene E-Mail Adresse.
          </h3>

          <hr class="green-line" />

          <p>
            Hinweis: Solltest du keine E-Mail erhalten haben, dann schau bitte auch in
            deinem SPAM-Ordner nach.
          </p>
          <h3 class="middle_header">
            Vielen Dank für deine Registrierung,<br />dein C4T-Team
          </h3>

          <v-btn color="green white--text" @click="toLogin()">Zum Login</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <CroppieDialog
      ref="croppieDialog"
      :image="imageSrc"
      :show.sync="showCroppie"
      @upload="cropRegistrationAvatar"
    />
  </div>
</template>

<script>
import axios from 'axios';
import firebase from 'firebase';
import { db } from '@/db';
import croppieMixin from '../../mixins/croppie';
import pushMixin from '../../mixins/push-notifications';
import registerMixin from '../../mixins/register';
import CroppieDialog from '../../components/dialogs/CroppieDialog';
import { cloudFunctions } from '../../config';

export default {
  name: 'register-player',

  data: () => ({
    checkbox_anb: false,
    checkbox_datenschutz: false,
    menu: false,
    selectedStep: 1,
    date: null,
    common_infos: {
      date: '2018-03-02',
      profile_pic: '',
      history: [],
    },
    settings: {
      no_team: true, // be carefull, before fix it was set to ja/nein, but switch to true/false too, so its little wired how it works now > see: UserBio.vue
    },
    loading: false,
    email: '',
    name: '',
    password: '',
    picture: '',
    uploading: false,
    select: { state: 'Florida', abbr: 'FL' },
    landkreis: ['Ohrekreis', 'Salzlandkreis', ''],
    player_types: [
      'Führungsspieler',
      'Harter Spieler',
      'Ballgewinner',
      'Geht lange Wege',
      'Spieleröffner',
      'Spielzerstörer',
      'Sechser',
      'Achter',
      'Zehner',
      'Freistoßexperte',
      'Einfache Pässe',
      'Dribbler',
      'Sturmtank',
      'Ballhalter',
      'Torjäger',
    ],
    items: ['Profi', 'Amateur', 'Halbprofi'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    showPW: false,
    rules: {
      required: (value) => !!value || '*Pflichtfeld.',
      min: (v) => v.length >= 8 || '*min. 8 Zeichen',
    },
  }),

  components: {
    CroppieDialog,
  },

  mixins: [croppieMixin, pushMixin, registerMixin],

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },

  computed: {
    playerSpecificPosition() {
      if (this.settings.position === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.settings.position === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.settings.position === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      return [];
    },
    playerSpecificSecondPosition() {
      if (this.settings.secondPosition === 'Angriff') {
        return this.$store.state.strikerTypes;
      }
      if (this.settings.secondPosition === 'Verteidiger') {
        return this.$store.state.guardTypes;
      }
      if (this.settings.secondPosition === 'Mittelfeld') {
        return this.$store.state.midfieldType;
      }
      return [];
    },
  },
  methods: {
    next() {
      this.selectedStep++;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerPlayer',
      });
      window.scrollTo(0, 0);
    },
    back() {
      this.selectedStep--;
      this.$gtm.push({
        event: 'registration',
        registration_progress: `step ${this.selectedStep}`,
        registration_category: 'registerPlayer',
      });
      window.scrollTo(0, 0);
    },
    setSpecificPosition(position) {
      this.$set(this.settings, 'position_specific', null);
      if (position === 'Torhüter') {
        this.settings.position_specific = 'Torhüter';
      }
    },
    setSpecificSecondPosition(position) {
      this.$set(this.settings, 'second_position_specific', null);
      if (position === 'Torhüter') {
        this.$set(this.settings, 'second_position_specific', 'Torhüter');
      }
    },
    limiter(e) {
      if (e.length > 3) {
        e.pop();
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Maximal 3 Spielertypen',
        });
      }
    },

    // saveSettings() {
    //   this.loading = true;
    //   if (this.common_infos.fupa) {
    //     this.common_infos.fupa = this.common_infos.fupa.replace('https://', '');
    //   }
    //   if (this.common_infos.transfermarkt) {
    //     this.common_infos.transfermarkt = this.common_infos.transfermarkt.replace(
    //       'https://',
    //       '',
    //     );
    //   }
    //   if (this.common_infos.facebook) {
    //     this.common_infos.facebook = this.common_infos.facebook.replace(
    //       'https://',
    //       '',
    //     );
    //   }
    //   if (this.common_infos.instagram) {
    //     this.common_infos.instagram = this.common_infos.instagram.replace(
    //       'https://',
    //       '',
    //     );
    //   }
    //   const nationality = this.$store.state.nationalities.find(n => n.item_text === this.settings.living_in_country);
    //   const defaultFilterSettings = {
    //     search_nationality: nationality.id,
    //   };

    //   db.collection('users')
    //     .doc(this.$store.state.user_uid)
    //     .update({ ...this.settings, ...this.common_infos, ...defaultFilterSettings })
    //     .then(() => {
    //       this.loading = false;
    //       this.selectedStep++;
    //     })
    //     .then((e) => {
    //       this.loading = false;
    //     });
    // },

    loginUser(email, password) {
      this.$store.state.credentials = {
        password,
        email,
      };
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userRecord) => {
          const { user } = userRecord;

          const user_id = user.uid;
          this.$store.state.user_id = user_id;
          const userType = user.displayName;
          this.$store.state.userType = userType;
          return { user_id, userType };
        })
        .then((resp) => db.collection(resp.userType).doc(resp.user_id).get())
        .then((snapshot) => {
          const document = snapshot.data();
          this.$store.state.user_data = document;

          return document.userType;
        })
        .then(async (userType) => {
          this.$store.dispatch('bindUserData');
          await this.setDefaultMessagingSettings(this.user_data);
          return userType;
        })
        .then((userType) => {
          if (userType === 'scout') {
            this.$router.push({
              name: 'scout_home',
            });
          } else if (this.$store.state.userType === 'teams') {
            this.$router.push({
              name: 'team_home',
            });
          } else if (userType === 'trainer') {
            this.$router.push({
              name: 'trainer_home',
            });
          } else {
            this.$router.push({
              name: 'home',
            });
          }
        })
        .catch((error) => {
          if (error.code === 'auth/email-already-exists') {
            this.$store.state.snackText = 'Email existiert schon';
            this.$store.state.snackbar = true;
          }
          if (
            error.code === 'auth/wrong-password' ||
            error.code === 'auth/user-not-found'
          ) {
            this.$store.state.snackText = 'Falsche Logindaten';
            this.$store.state.snackbar = true;
          }
          if (error.code === 'auth/invalid-email') {
            this.$store.state.snackText = 'E-Mail hat das falsche Format';
            this.$store.state.snackbar = true;
          }
        });
    },

    login(email, password) {
      this.$store.state.credentials = {
        password,
        email,
      };
      this.$store.state.snackText = 'Nutzer erfolgreich angemeldet';
      this.$store.state.snackbar = true;
      if (localStorage.aff) {
        db.collection('users')
          .doc(this.$store.state.user_uid)
          .update({ affilliateID: localStorage.aff })
          .then(() => {
            this.loginUser(email.toLowerCase().trim(), password);
          });
      } else {
        this.loginUser(email.toLowerCase().trim(), password);
      }
    },

    registerPlayer() {
      this.loading = true;

      const nationality = this.$store.state.nationalities.find(
        (n) => n.item_text === this.settings.place_of_living,
      );
      const defaultFilterSettings = {
        search_nationality: nationality.id,
      };

      const data = {
        ...this.settings,
        ...this.common_infos,
        ...defaultFilterSettings,
        email: this.email,
        password: this.password,
      };

      if (localStorage.aff) {
        data.affilliateID = localStorage.aff;
      }

      const json = JSON.stringify(data);
      axios({
        method: 'post',
        url: `${cloudFunctions}/createPlayerV2`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: json,
      })
        .then((resp) => {
          this.$store.state.user_uid = resp.data.uid;
          this.loading = false;
        })
        // .then(() => {
        //   firebase.auth().signInWithEmailAndPassword(this.email.toLowerCase().trim(), this.password);
        // })
        .then(() => {
          this.selectedStep++;
          window.scrollTo(0, 0);
          this.$gtm.push({
            event: 'registration',
            registration_progress: 'success',
            registration_category: 'registerPlayer',
          });
        })
        .catch((e) => {
          this.loading = false;

          if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/invalid-email'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email hat ein falsches Format.',
            });
          } else if (
            e.response &&
            e.response.data &&
            e.response.data.error.code === 'auth/email-already-exists'
          ) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Die Email existiert schon.',
            });
          } else {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Ups. Da ist wohl etwas schief gelaufen',
            });
          }
        });
    },
  },
  beforeMount() {
    this.$gtm.push({
      event: 'registration_start',
      registration_progress: 'start',
      registration_category: 'registerPlayer',
    });
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = '';
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';
.green-line {
  height: 0;
  border: 0;
  border-bottom: 5px solid $primary-dark;
  border-radius: 4px;
  margin: 40px 20%;
}

.middle_header {
  text-align: center;
  margin-bottom: 4px !important;
  font-weight: 600;
}

.register {
  padding: 0;
  margin: 0;
  text-align: center;
}

.v-btn {
  margin-left: 0;
  border-radius: 15px;
  padding: 15px 30px;

  &.green {
    @include mainLinearGradient;
  }
}

.stepper {
  width: 100%;
  min-height: 100vh;
}

h3 {
  color: $secondary-light;
}

.link-no-team,
a {
  color: #24a23d;
}

label {
  font-weight: bold;
  color: $secondary-dark;
  text-align: center;
  font-size: 1.5rem;

  span:last-of-type {
    color: $secondary-light;
  }
}

.items {
  width: 100%;
  background: rgb(248, 248, 248);
  min-height: 93vh;
}

.datepicker {
  margin-bottom: 20px;
}

.items-1 {
  text-align: center;
}

h1 {
  margin-top: 1rem;
}

h2 {
  color: rgb(34, 34, 34);
  font-weight: 400;
  font-size: 20px;
  font-weight: 500;
}
.small-icon {
  align-self: center;
  height: 33px;
}

.icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
